import React from "react";
function useRovingIndex(maxIndex, initialIndex, doWrap) {
    if (initialIndex === void 0) { initialIndex = 0; }
    if (doWrap === void 0) { doWrap = true; }
    var _a = React.useState(initialIndex), currentIndex = _a[0], setIndex = _a[1];
    function decrementIndex() {
        if (currentIndex === 0 && doWrap) {
            setIndex(maxIndex);
            return;
        }
        if (currentIndex > 0) {
            setIndex(function (i) { return i - 1; });
            return;
        }
    }
    function incrementIndex() {
        if (currentIndex === maxIndex && doWrap) {
            setIndex(0);
            return;
        }
        if (currentIndex < maxIndex) {
            setIndex(function (i) { return i + 1; });
            return;
        }
    }
    function updateIndex(nextIndex) {
        if (nextIndex >= 0 && nextIndex <= maxIndex) {
            setIndex(nextIndex);
        }
    }
    return [currentIndex, updateIndex, decrementIndex, incrementIndex];
}
export default useRovingIndex;
//# sourceMappingURL=useRovingIndex.js.map